import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';

export function useMyChildren(options = {}) {
  return useQuery({
    queryKey: ['myChildren'],
    queryFn: api.auth.myChildren,
    staleTime: 2 * 60 * 1000,
    refetchOnWindowFocus: false,
    ...options,
  });
}

export default useMyChildren;
